import type { ReactNode } from "react";
import { UpdateBannerSlot } from "@features/updater";
import { AppChrome } from "@widgets/titlebar";

/** Единая рамка обычного режима: titlebar, уведомления и экран приложения. */
export function AppSurface({ children }: { children: ReactNode }) {
  return (
    <AppChrome notice={<UpdateBannerSlot />} fallbackSubtitle="обновление">
      {children}
    </AppChrome>
  );
}
